<template>
  <v-container>
    <div id="page-heading" class="grey--text text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2">
      Upcoming tutorials
    </div>

    <v-row flex>
      <v-col cols="12" v-for="teachingSession in upcomingTeachingSessions" :key="teachingSession.id">
        <v-card outlined>
          <v-card-title>
            <span>{{ teachingSession.tutorial.subject.data.title }} > {{ teachingSession.tutorial.data.title }}</span>
            <v-spacer />
            <v-chip v-if="teachingSession.inProgress"
              color="green"
              text-color="white"
              class="text-uppercase"
            >
              In progress
            </v-chip>
            <v-chip v-if="teachingSession.inGracePeriod"
              color="red"
              text-color="white"
              class="text-uppercase"
            >
              Ending soon
            </v-chip>
            <v-btn depressed color="primary" class="ml-3" small router :to="{ name: 'Attempt', params: { id: teachingSession.attempts[0].id } }">
              Open
            </v-btn>
          </v-card-title>
          <v-card-subtitle>{{ teachingSession.data.startTime | date('EEE do MMM yyyy, HH:mm') }} - {{ teachingSession.data.endTime | date('HH:mm') }}</v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="upcomingTeachingSessions.length == 0">
        <v-card outlined>
          <v-card-title>
            You have no upcoming tutorials
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <div class="grey--text text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2">
      Past tutorials
    </div>

    <v-row flex>
      <v-col cols="12" v-for="teachingSession in pastTeachingSessions" :key="teachingSession.id">
        <v-card outlined>
          <v-card-title>
            <span>{{ teachingSession.tutorial.subject.data.title }} > {{ teachingSession.tutorial.data.title }}</span>
            <v-spacer />
            <v-btn depressed color="primary" class="ml-3" small router :to="{ name: 'Attempt', params: { id: teachingSession.attempts[0].id } }">
              Open
            </v-btn>
          </v-card-title>
          <v-card-subtitle>{{ teachingSession.data.startTime | date('EEE do MMM yyyy, HH:mm') }} - {{ teachingSession.data.endTime | date('HH:mm') }}</v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="pastTeachingSessions.length == 0">
        <v-card outlined>
          <v-card-title>
            You have no past tutorials
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import addMinutes from 'date-fns/addMinutes'

export default {
  name: "StudentDashboard",
  data: function() {
    return { 
    }
  },
  computed: {
    ...mapGetters({
      studentSubjects: "studentSubjects"
    }),
    teachingSessions() {

      let teachingSessions = []
      
      this.studentSubjects.forEach(subject => {
        subject.tutorials && subject.tutorials.forEach(tutorial => {
          tutorial.teachingSessions && tutorial.teachingSessions.forEach(teachingSession => {

            // Do not add the teaching session until the associated attempt has been added
            if (teachingSession.attempts) {
              // Check if the teachingSession ends in the future (it may already have started)
              // Allow 15 minutes grace period at end of the tutorial to handle any student requests
              const now = new Date()
              const endTimewithGrace = addMinutes(teachingSession.data.endTime, 15)
              // Check if the teachingSession is in progress or in the grace period
              teachingSession.inProgress = teachingSession.data.startTime < now && now < teachingSession.data.endTime
              teachingSession.inGracePeriod = teachingSession.data.endTime < now && endTimewithGrace > now
              teachingSessions.push(teachingSession)
            }
          })
        })
      })
      // Order by start time
      teachingSessions.sort((a, b) => a.data.startTime - b.data.startTime)

      return teachingSessions
    },
    upcomingTeachingSessions() {
      return this.teachingSessions.filter(teachingSession => {
        return teachingSession.inProgress || teachingSession.inGracePeriod
      })
    },
    pastTeachingSessions() {
      return this.teachingSessions.filter(teachingSession => {
        return !(teachingSession.inProgress || teachingSession.inGracePeriod)
      })
    }
  }
}
</script>
